import * as React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import { makeStyles } from '@material-ui/core/styles';
import CardContent from '@mui/material/CardContent';

const useStyles = makeStyles({
  card: {
    marginBottom: 8,
  },
});

export default function Execute(props) {  
  const css = useStyles();

  function goDetail(obj){
    props.goToDetail(obj);
  }

  return (<>
    <Box >
      {(props.rows && props.rows.length>0)?<>
        {props.selectTab>1?
        <>
          {props.rows.map((myObj,i)=>(
            <Card key={'crd'+i} className={css.card} style={{cursor:'pointer'}} onClick={()=>{goDetail(myObj)}} >
              <CardContent>
                <b>{myObj.mockTestName}</b><br/>
                Date: {myObj.submitDateTime}, 
                Questions: {myObj.totalQuestions},
                Full Marks: {myObj.fullMarks},  
                Marks Obtain: {myObj.marksObtain},
                Time Spent: {myObj.timeSpent},
              </CardContent>
            </Card>      
          ))}   
        </>  
        :<>
          {props.rows.map((myObj,i)=>(
            <Card key={'crd'+i} className={css.card} style={{cursor:'pointer'}} onClick={()=>{goDetail(myObj)}} >
              <CardContent>
                <b>{myObj.mockTestName}</b><br/>
                Date: {myObj.submitDateTime}, 
                Questions: {myObj.totalQuestions},
                Help in Questions: {myObj.helpCounter},  
                Correct: {myObj.correctQuestions},
                Incorrect: {myObj.incorrectQuestions},
                Unattempted: {myObj.unattemptedQuestions}
              </CardContent>
            </Card>      
          ))}   
        </>}
      </>:<>No row found</>} 
    </Box>
  </>);
}